import React, { useEffect, useState } from "react";
import EditModal from "./shared/EditModal";
import { MdEdit,MdClose} from "react-icons/md";
import SUG from "./shared/suggestions";

export default function LanguagesSection({ value = [], onChange }) {
  const [langs, setLangs] = useState(value || []);
  const [open, setOpen] = useState(false);
  const [editIdx, setEditIdx] = useState(null);

  useEffect(() => setLangs(value || []), [value]);

  // Define available proficiency levels
  const levels = ["Beginner", "Intermediate", "Fluent"];

  const openAdd = () => {
    setEditIdx(null);
    setOpen(true);
  };

  const openEdit = (i) => {
    setEditIdx(i);
    setOpen(true);
  };

  const save = (data) => {
    const lang = (data.language || "").trim();
    const level = data.level || "Beginner";
    if (!lang) return;

    let next;
    if (editIdx == null) next = [...langs, { language: lang, level }];
    else {
      next = [...langs];
      next[editIdx] = { language: lang, level };
    }

    setLangs(next);
    onChange(next);
  };

  const remove = (i) => {
    const next = langs.filter((_, idx) => idx !== i);
    setLangs(next);
    onChange(next);
  };

  return (
    <section className="ccard">
      <div className="card-head">
        <h3>Languages</h3>
        <div className="card-actions">
          <button className="link" onClick={openAdd}>
            Add
          </button>
        </div>
      </div>

      <div className="card-body">
        {langs.length === 0 ? (
          <p className="muted">No languages</p>
        ) : (
          <div className="chips">
            {langs.map((l, i) => (
              <div className="chip lang-chip" key={i}>
                <span className="chip-text">
                  {l.language}{" "}
                  
                  <span className={`level-badge level-${(l.level || "Beginner").toLowerCase()}`}>
                    {l.level}
                  </span>
                </span>
                <div className="chip-buttons">
                  <MdEdit className="edit" onClick={() => openEdit(i)}/>
                  <MdClose className="x" onClick={() => remove(i)}/>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {open && (
        <EditModal
          title={editIdx == null ? "Add Language" : "Edit Language"}
          initial={editIdx == null ? { language: "", level: "Beginner" } : langs[editIdx]}
          fields={[
            {
              name: "language",
              label: "Language",
              type: "text",
              suggestList: SUG.languages,
            },
            {
              name: "level",
              label: "Proficiency Level",
              type: "select",
              options: levels,
            },
          ]}
          onClose={() => setOpen(false)}
          onSave={(d) => {
            save(d);
            setOpen(false);
          }}
        />
      )}
    </section>
  );
}
